import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './auth';
//component
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { BusinessComponent } from './business/business.component';

const routes = [
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule),
  },
  {
    path: 'support-business',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule),
  },
  {
    path: 'not-business',
    canActivate: [AuthGuard],
    loadChildren: () => import('./not-business/not-business.module').then(mod => mod.NotBusinessModule),
  },
  {
    path: 'business',
    canActivate: [AuthGuard],
    loadChildren: () => import('./business/business.module').then(mod => mod.BusinessModule),
    component: BusinessComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  },
]
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
